import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-invite-user-modal',
  templateUrl: './invite-user-modal.component.html',
  styleUrls: ['./invite-user-modal.component.scss'],
  standalone: true,
  imports: [MatIconModule, TranslateModule, NgOptimizedImage]
})
export class InviteUserModalComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<InviteUserModalComponent>,
  ) { }

  ngOnInit(): void {
  }

  public goRoute(type: string): void {
    switch (type) {
      case 'appStore':
        window.open('https://apps.apple.com/mx/app/alsuperapp/id1445790957');
        break;
      case 'googlePlay':
        window.open('https://play.google.com/store/apps/details?id=com.exosfera.alsuper&hl=es_MX');
        break;
    }
  }

  public closeDownloadAppsBanner() {
    this.dialogRef.close();
  }

}
